import api from './api';

export const getSubscriptions = async () => {
  const { data } = await api.get('/subscriptions');
  return data;
};

export const chooseSubscription = async (subscriptionId) => {
  const { data } = await api.post('/users/me/subscription', { subscription_id: subscriptionId });
  return data;
};

export const cancelSubscription = async () => {
  const { data } = await api.delete('/users/me/subscription');
  return data;
};

export const activateTrial = async () => {
  const { data } = await api.post('/users/me/trial');
  return data;
};

export const activatePromo = async (code) => {
  const { data } = await api.post('/users/me/promo-code', { code });
  return data;
};

export const syncVpn = async () => {
  const { data } = await api.post('/users/me/vpn/sync');
  return data;
};

export const spinRoulette = async (stake) => {
  const { data } = await api.post('/users/me/roulette/spin', { stake });
  return data;
};

export const getRouletteStatus = async () => {
  const { data } = await api.get('/users/me/roulette');
  return data;
};
